(() => {
  const roots = document.querySelectorAll('[data-selection-support]');

  roots.forEach((root) => {
    const markers = [...root.querySelectorAll('[data-selection-marker]')];
    const steps = [...root.querySelectorAll('[data-selection-step]')];

    if (!markers.length || !steps.length) return;

    const activate = (index) => {
      const value = String(index);

      markers.forEach((marker) => {
        const isActive = marker.dataset.selectionMarker === value;
        marker.classList.toggle('is-active', isActive);
        if (isActive) marker.setAttribute('aria-current', 'step');
        else marker.removeAttribute('aria-current');
      });

      steps.forEach((step) => {
        step.classList.toggle('is-active', step.dataset.selectionStep === value);
      });
    };

    markers.forEach((marker) => {
      marker.addEventListener('mouseenter', () => activate(marker.dataset.selectionMarker));
      marker.addEventListener('focus', () => activate(marker.dataset.selectionMarker));
      marker.addEventListener('click', () => {
        const value = marker.dataset.selectionMarker;
        const target = steps.find((step) => step.dataset.selectionStep === value);
        activate(value);

        if (target && window.matchMedia('(max-width: 42rem)').matches) {
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'center'
          });
        }
      });
    });

    steps.forEach((step) => {
      step.addEventListener('mouseenter', () => activate(step.dataset.selectionStep));
      step.addEventListener('focusin', () => activate(step.dataset.selectionStep));
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!window.matchMedia('(max-width: 42rem)').matches) return;
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) activate(visible.target.dataset.selectionStep);
      }, { rootMargin: '-32% 0px -46% 0px', threshold: [0.2, 0.55, 0.8] });

      steps.forEach((step) => observer.observe(step));
    }
  });
})();
